import { AlertOctogonalIcon, CircleCheckIcon } from '../../../../icons';
import { type AutoneIconComponent } from '../../../../icons/factory/create-icon-component';
import {
  type DatasetDataFreshnessStatus,
  type DatasetsDataFreshnessStatus,
} from '../DataFreshnessWidget.types';

export const dataFreshnessStatusIconMap: Record<
  NonNullable<DatasetsDataFreshnessStatus | DatasetDataFreshnessStatus>,
  AutoneIconComponent
> = {
  some_datasets_old: AlertOctogonalIcon,
  all_datasets_old: AlertOctogonalIcon,
  old: AlertOctogonalIcon,
  new: CircleCheckIcon,
  all_datasets_new: CircleCheckIcon,
};
